var _rect, _rect2, _rect3, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _rect4, _polygon6, _polygon7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPA3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 990 720"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-id": "A.3.1",
    x: 249,
    y: 380,
    width: 90,
    height: 128
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "A.3.2",
    x: 96,
    y: 380,
    width: 148.03,
    height: 128
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "A.3.3",
    x: 85.05,
    y: 182,
    width: 130.95,
    height: 193
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.3.4",
    points: "221.21 182 339 182 339 339 247 339 247 329 221 329 221 182 221.21 182"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.3.5",
    points: "344 199 462 199 462 329 437 329 437 339 344 339 344 199"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.3.6",
    points: "466.88 199 585 199 585 340 492.74 340 492.74 329 466.88 329 466.88 199"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.3.7",
    points: "589.87 199 708 199 708 329 682 329 682 339 589.87 339 589.87 199"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.3.8",
    points: "713 211 892 211 892 375 810.55 375 810.55 339 713 339 713 211"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "A.3.9",
    x: 712.66,
    y: 380,
    width: 191.34,
    height: 158
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.3.10",
    points: "708 380 708 538 589.98 538 589.98 390 615 390 615 380 708 380"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.3.11",
    points: "585 390.46 585 520 466.74 520 466.74 380 559 380 559 390 585 390.46"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyAKICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgCiAgICB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgCiAgICB2aWV3Qm94PSIwIDAgOTkwIDcyMCIKPgogICAgPHJlY3QgZGF0YS1pZD0iQS4zLjEiIHg9IjI0OSIgeT0iMzgwIiB3aWR0aD0iOTAiIGhlaWdodD0iMTI4Ii8+CiAgICA8cmVjdCBkYXRhLWlkPSJBLjMuMiIgeD0iOTYiIHk9IjM4MCIgd2lkdGg9IjE0OC4wMyIgaGVpZ2h0PSIxMjgiLz4KICAgIDxyZWN0IGRhdGEtaWQ9IkEuMy4zIiB4PSI4NS4wNSIgeT0iMTgyIiB3aWR0aD0iMTMwLjk1IiBoZWlnaHQ9IjE5MyIvPgogICAgPHBvbHlnb24gZGF0YS1pZD0iQS4zLjQiIHBvaW50cz0iMjIxLjIxIDE4MiAzMzkgMTgyIDMzOSAzMzkgMjQ3IDMzOSAyNDcgMzI5IDIyMSAzMjkgMjIxIDE4MiAyMjEuMjEgMTgyIi8+CiAgICA8cG9seWdvbiBkYXRhLWlkPSJBLjMuNSIgcG9pbnRzPSIzNDQgMTk5IDQ2MiAxOTkgNDYyIDMyOSA0MzcgMzI5IDQzNyAzMzkgMzQ0IDMzOSAzNDQgMTk5Ii8+CiAgICA8cG9seWdvbiBkYXRhLWlkPSJBLjMuNiIgcG9pbnRzPSI0NjYuODggMTk5IDU4NSAxOTkgNTg1IDM0MCA0OTIuNzQgMzQwIDQ5Mi43NCAzMjkgNDY2Ljg4IDMyOSA0NjYuODggMTk5Ii8+CiAgICA8cG9seWdvbiBkYXRhLWlkPSJBLjMuNyIgcG9pbnRzPSI1ODkuODcgMTk5IDcwOCAxOTkgNzA4IDMyOSA2ODIgMzI5IDY4MiAzMzkgNTg5Ljg3IDMzOSA1ODkuODcgMTk5Ii8+CiAgICA8cG9seWdvbiBkYXRhLWlkPSJBLjMuOCIgcG9pbnRzPSI3MTMgMjExIDg5MiAyMTEgODkyIDM3NSA4MTAuNTUgMzc1IDgxMC41NSAzMzkgNzEzIDMzOSA3MTMgMjExIi8+CiAgICA8cmVjdCBkYXRhLWlkPSJBLjMuOSIgeD0iNzEyLjY2IiB5PSIzODAiIHdpZHRoPSIxOTEuMzQiIGhlaWdodD0iMTU4Ii8+CiAgICA8cG9seWdvbiBkYXRhLWlkPSJBLjMuMTAiIHBvaW50cz0iNzA4IDM4MCA3MDggNTM4IDU4OS45OCA1MzggNTg5Ljk4IDM5MCA2MTUgMzkwIDYxNSAzODAgNzA4IDM4MCIvPgogICAgPHBvbHlnb24gZGF0YS1pZD0iQS4zLjExIiBwb2ludHM9IjU4NSAzOTAuNDYgNTg1IDUyMCA0NjYuNzQgNTIwIDQ2Ni43NCAzODAgNTU5IDM4MCA1NTkgMzkwIDU4NSAzOTAuNDYiLz4KPC9zdmc+";
export { SvgPA3 as ReactComponent };